import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectVerificationProfile } from 'selectors/devices';
import AbsoluteVerification from './Absolute';
import DeltaVerification from './Delta';

// An absolute comparison weighs the meter against the technician in one reading; a delta
// weighs one reading against the one before it.
const SCREENS = { absolute: AbsoluteVerification, delta: DeltaVerification };

// No fallback on purpose: a device without a profile cannot be verified at all.
const Verification = ({ device }) => {
    const profile = useSelector(useMemo(() => selectVerificationProfile(device.id), [device.id]));
    if (!profile) {
        return null;
    }

    const Screen = SCREENS[profile.comparison];
    return <Screen device={device}/>;
};

export default Verification;
